import React from 'react';
import PrivateRoute from '@cedalo/webui/src/components/Auth/PrivateRoute';
import { Route } from 'react-router-dom';
import { WorkspaceOverviewPage, CreateWorkspacePage, EditWorkspacePage, ScopeHandler } from './workspace';
import SharedMachinePage from './sharemachine/SharedMachinePage';

export function RoutesExtensions() {
	return (
		<React.Fragment>
			<Route path="/shared-machine/:linkId" component={SharedMachinePage} />
			<PrivateRoute exact path="/administration/workspaces" component={WorkspaceOverviewPage} />
			<PrivateRoute exact path="/administration/workspaces/new" component={CreateWorkspacePage} />
			<PrivateRoute
				exact
				path="/administration/workspaces/:workspaceId([^\/]{4,})"
				component={EditWorkspacePage}
			/>
			<ScopeHandler/>
		</React.Fragment>
	);
}



// WEBPACK FOOTER //
// /home/travis/build/cedalo/streamsheets-pro-features/packages/webui-extensions/src/RoutesExtensions.js